import { Component, Input } from '@angular/core';
import { StatusEnum } from '../../models/status.enum';

@Component({
  selector: 'app-status-tag',
  templateUrl: './status-tag.component.html',
  styleUrl: './status-tag.component.scss',
})
export class StatusTagComponent {
  @Input() backgroundColor: string = 'white';
  @Input() borderColor: string = 'black';
  @Input() icon: string = '';
  @Input() label: string = '';
  @Input() textColor: string = 'black';
}
